import {
  Box,
  Text,
  ContentBlock,
  Stack,
  Inline,
  TextLink,
} from 'braid-design-system';

export const Footer = () => (
  <Box background="neutralLight" padding="gutter">
    <ContentBlock>
      <Stack space="large">
        <Inline space="gutter">
          <Text>
            <TextLink href="/about">About the PFA</TextLink>
          </Text>
          <Text>
            <TextLink href="/contact">Contact Us</TextLink>
          </Text>
        </Inline>
      </Stack>
    </ContentBlock>
  </Box>
);
